// @flow
import React, { useState, useEffect } from "react";
import bem from "@justpark/helpers/src/bem/bem";
import FacilitiesIcon from "./FacilitiesIcon";
import Typography from "../Typography";
import LinkButton from "../LinkButton";

import "./facilities.scss";

type facility = {
  id: string,
  isRestricted?: boolean,
  hidden?: boolean,
  description: string,
  title: string
};
type Props = {
  items: Array<facility>,
  isExpanded: boolean,
  t?: (string, string) => string
};

const hiddenFacilities = ["start_stop", "has_multiple_entry"];
const filterItems = (newItems) =>
  newItems.filter((item) => hiddenFacilities.indexOf(item.id) === -1);

const Facilities = ({ items, isExpanded, t }: Props) => {
  const [facilities, setFacilities] = useState(() => {
    return filterItems(items);
  });
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setFacilities(filterItems(items));
  }, [items]);

  useEffect(() => {
    setExpanded(isExpanded);
  }, [isExpanded]);

  const listItems = () =>
    expanded ? facilities : facilities.slice(0, facilities.length > 4 ? 3 : 4);

  const toggle = () => {
    setExpanded({ expanded: !expanded });
  };
  const baseClass = "c-facilities";

  if (!facilities.length) {
    return null;
  }
  return (
    <ul className={baseClass}>
      {listItems().map(({ id, title }) => (
        <li key={`${id}`} className={bem(baseClass, "item")}>
          <FacilitiesIcon iconName={id} />
          <Typography size="subtext2" className={bem(baseClass, "description")}>
            {title === "24x7" ? `Available 24x7` : title}
          </Typography>
        </li>
      ))}
      {!expanded && facilities.length > 4 && (
        <li className={bem(baseClass, "item")}>
          <LinkButton onClick={toggle}>
            <div className={bem(baseClass, "more")}>
              +{facilities.length - 3}
            </div>
            <Typography
              className={bem(baseClass, "description", {
                "show-all": !expanded
              })}
              size="subtext2"
            >
              {t("cta:showAllFacilities", "Show All Facilities")}
            </Typography>
          </LinkButton>
        </li>
      )}
    </ul>
  );
};

Facilities.defaultProps = {
  isExpanded: false,
  t: (key, defaultValue) => defaultValue
};
export default Facilities;
